package com.bulut.mecitogullari.core.storage

import com.russhwolf.settings.Settings
import kotlinx.serialization.KSerializer
import kotlinx.serialization.json.Json

/**
 * [AppStorage] implementation backed by multiplatform-settings:
 * SharedPreferences on Android, NSUserDefaults on iOS, localStorage on web.
 *
 * Objects are stored as JSON strings via kotlinx.serialization.
 */
class SettingsAppStorage(
    private val settings: Settings,
    private val json: Json,
) : AppStorage {

    override fun putString(key: String, value: String) = settings.putString(key, value)

    override fun getString(key: String, defaultValue: String?): String? =
        settings.getStringOrNull(key) ?: defaultValue

    override fun putBoolean(key: String, value: Boolean) = settings.putBoolean(key, value)

    override fun getBoolean(key: String, defaultValue: Boolean): Boolean =
        settings.getBoolean(key, defaultValue)

    override fun <T> putObject(key: String, value: T, serializer: KSerializer<T>) =
        settings.putString(key, json.encodeToString(serializer, value))

    override fun <T> getObject(key: String, serializer: KSerializer<T>): T? =
        settings.getStringOrNull(key)?.let { raw ->
            runCatching { json.decodeFromString(serializer, raw) }.getOrNull()
        }

    override fun remove(key: String) = settings.remove(key)

    override fun contains(key: String): Boolean = settings.hasKey(key)

    override fun clear() = settings.clear()
}
